<div class="row">
  <div class="col-md-12">
    <div class="description">{{'paymentTypes.description' | cxTranslate }}</div>
    @if (paymentTypes$ | async; as paymentTypes) {
      <div role="status" [attr.aria-label]="'common.loaded' | cxTranslate"></div>
      @for (type of paymentTypes$ | async; track type) {
        <label class="cx-payment-type-container">
          <span class="form-check payments-type-check">
            <input id="paymentType-{{ type?.code }}" class="form-check-input" role="radio" type="radio"
              aria-checked="true" (change)="changeType(type.code)" [value]="type?.code"
              [checked]="type?.code === typeSelected" />
            <label class="cx-payment-type-label form-check-label form-radio-label" for="paymentType-{{ type?.code }}">
              <span class="cx-payment-type">
                {{ 'paymentTypes.paymentType' | cxTranslate: {context: type?.code} }}
              </span>
              <cx-media [container]="type.media"></cx-media>
            </label>
          </span>
          @if (type?.code === 'sp1') {
            @if (bannersSequra) {
              <div class="sequra-promotion-widget" [attr.data-amount]="totalWithTax" data-product="sp1" data-size="S"
              data-type="text"></div>
            } @else {
              <div class="fa-3x text-center">
                <i class="fas fa-spinner fa-pulse font-size-20"></i>
              </div>
            }
          }
          @if (type?.code === 'pp3') {
            @if (bannersSequra) {
              <div class="sequra-promotion-widget" data-product="pp3" [attr.data-amount]="totalWithTax" data-size="S"
              data-type="text"></div>
            } @else {
              <div class="fa-3x text-center">
                <i class="fas fa-spinner fa-pulse font-size-20"></i>
              </div>
            }
          }
        </label>
      }
    <!--  </ng-container> -->
    <cx-place-order (loaderEvent)="onLoadingStatusChange($event)" [typeSelected]="typeSelected"></cx-place-order>
  }
</div>
</div>

